import { useState } from "react";
import PostPurchaseUpsell from "./postPurchaseUpsell";
import PostPurchaseRoulette from "./postPurchaseRoulette";
import PostPurchaseChristmasTree from "./postPurchaseChristmasTree";

export default function PostPurchaseEvents({
    onFinish, isInModal = false
}) {

    const [currentEvent, setCurrentEvent] = useState(0);

    const postPurchaseEvents = [
        {
            key: 'roletaFestaJunina',
            Component: PostPurchaseRoulette,
        },
        {
            key: 'upsell',
            Component: PostPurchaseUpsell,
        },
        {
            key: 'christmas2025',
            Component: PostPurchaseChristmasTree,
        }
    ];

    const handleEventClose = () => {
        if (currentEvent >= postPurchaseEvents.length - 1) {
            onFinish();
            return;
        }

        setCurrentEvent(prev => prev + 1);
    }

    const Component = postPurchaseEvents[currentEvent].Component;

    return (
        <div>
            <Component onClose={handleEventClose} isInModal={isInModal} />
        </div>
    );
}